// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bBeh","clinicsSelect":"styles_clinicsSelect__2JD9X"};